import React, { Fragment, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../component/layout/header";
import Footer from "../component/layout/footer";
 import useCities from "../hooks/useCities";
 import rimage from "../assets/images/art/profile_image.jpg"
import "../assets/css/studentProfile.css"; // Your existing CSS
import Swal from "sweetalert2";
import { useRef } from "react";

const EditStudentProfile = () => {
  const navigate = useNavigate();
  // const { getCityName } = useCities();
  
 
 const [formData, setFormData] = useState({
  full_name: "",
  email: "",
  phone_code: "+91",   // ✅ ADD
  phone: "",
  gender: "",
  dob: "",
  education: "",
  country_id: "",
  state_id: "",
  city_id: "",
  location: "",
  area: "",
  address1: "",
  address2: "",
  pincode: "",
   profession_id: "",
        profession_details: "",
        preferred_languages: [],

});

 const fieldRefs = {
  full_name: useRef(null),
  phone: useRef(null),
  gender: useRef(null),
  dob: useRef(null),
  profession_id: useRef(null),
  profession_details: useRef(null),
  preferred_languages: useRef(null),
  country: useRef(null),
  state: useRef(null),
  city: useRef(null),
  location: useRef(null),
  area: useRef(null),
  address1: useRef(null),
  pincode: useRef(null),
};

  const [errors, setErrors] = useState({});
  const [photo, setPhoto] = useState(null);
  // const [photoPreview, setPhotoPreview] = useState("");
  const [photoPreview, setPhotoPreview] = useState(rimage);

  const [apiCountries, setApiCountries] = useState([]);
  const [apiStates, setApiStates] = useState([]);
  const [apiCities, setApiCities] = useState([]);
  const [citySuggestions, setCitySuggestions] = useState([]);
  const [cityInput, setCityInput] = useState("");
const [filteredCities, setFilteredCities] = useState([]);
const [showCitySuggestions, setShowCitySuggestions] = useState(false);

 
  /* ------------------ LOAD PROFILE ------------------ */
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      alert("Login required");
      navigate("/login");
      return;
    }
 
    fetch("https://kalakakshaaha.com/kks/api/student/profile", {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          const p = data.profile;
 
          setFormData({
          full_name: p.full_name || "",
          email: p.email || "",
          phone_code: p.phone_code || "+91",  // ✅ HERE
          phone: p.phone || "",
          gender: p.gender || "",
          dob: p.date_of_birth ? p.date_of_birth.split(" ")[0] : "",
          education: p.education || "",
          country_id: p.country_id || "",
          state_id: p.state_id || "",
          city_id: p.city_id || "",
          location: p.location || "",
          area: p.area || "",
          address1: p.address_line1 || "",
          address2: p.address_line2 || "",
          pincode: p.pincode || "",
          profession_id:p.profession_id || "",
          profession_details:p.profession_details || "",
          // preferred_languages:p.languages || "",
        });
        // ✅ HANDLE LANGUAGES (JSON STRING → ARRAY)
if (p.languages) {
  let parsedLanguages = [];

  try {
    parsedLanguages =
      typeof p.languages === "string"
        ? JSON.parse(p.languages)
        : p.languages;
  } catch (e) {
    console.error("Language parse error", e);
  }

  // 🔥 Set chips
  setSelectedLanguages(parsedLanguages);

  // 🔥 Set IDs for submit
  setFormData(prev => ({
    ...prev,
    preferred_languages: parsedLanguages.map(l => l.id)
  }));
}

 
          if (p.student_profile_photo) {
setPhotoPreview(
  p.student_profile_photo
    ? `https://kalakakshaaha.com/uploads/students/${p.student_profile_photo}?t=${Date.now()}`
    : rimage
);

          }
        } else {
          alert("Session expired");
          navigate("/login");
        }
      })
      .catch(err => console.log("Error fetching profile:", err));
  }, [navigate]);
 
  // ------------------ LOAD COUNTRIES, STATES, CITIES ------------------
  
 
  useEffect(() => {
  fetch("https://kalakakshaaha.com/kks/api/v1/countries")
    .then(res => res.json())
    .then(data => data.success && setApiCountries(data.countries));
}, []);
useEffect(() => {
  if (!formData.country_id) return;

  fetch(`https://kalakakshaaha.com/kks/api/v1/states/${formData.country_id}`)
    .then(res => res.json())
    .then(data => data.success && setApiStates(data.states));
}, [formData.country_id]);
useEffect(() => {
  if (!formData.state_id) return;

  fetch(`https://kalakakshaaha.com/kks/api/v1/cities/${formData.state_id}`)
    .then(res => res.json())
    .then(data => data.success && setApiCities(data.cities));
}, [formData.state_id]);

const errorKeyMap = {
  country_id: "country",
  state_id: "state",
  city_id: "city",
 
};

  // ------------------ HANDLE INPUT ------------------
  const handleChange = (e) => {
  const { name, value } = e.target;

  setFormData(prev => {
    if (name === "country_id") {
      return { ...prev, country_id: value, state_id: "", cityId: "" };
    }

    if (name === "state_id") {
      return { ...prev, state_id: value, cityId: "" };
    }

    return { ...prev, [name]: value };
  });

  // setErrors(prev => ({ ...prev, [name]: "" }));
  // 🔥 CLEAR CORRECT ERROR KEY
  const errorKey = errorKeyMap[name] || name;
  setErrors(prev => ({ ...prev, [errorKey]: "" }));
};

 
  // ------------------ PHOTO PREVIEW ------------------
  const handlePhotoChange = e => {
    const file = e.target.files[0];
    setPhoto(file);
    setPhotoPreview(URL.createObjectURL(file));
  };
 
  /* ------------------ VALIDATION ------------------ */
  const validate = (cityIdOverride = null) => {
  let temp = {};

  const cityId = cityIdOverride ?? formData.city_id;

  if (!formData.full_name.trim()) temp.full_name = "Full name is required";
  // if (!formData.email.trim()) temp.email = "Email is required";
  if (!formData.phone.trim()) temp.phone = "Phone is required";
  if (!formData.gender) temp.gender = "Gender is required";
  if (!formData.dob) temp.dob = "Date of birth is required";
  // if (!formData.education.trim()) temp.education = "Education is required";
  if (!formData.country_id) temp.country = "Country is required";
  if (!formData.state_id) temp.state = "State is required";
  if (!cityId) temp.city = "City is required";   // 🔥 FIX
  if (!formData.location.trim()) temp.location = "Location is required";
  if (!formData.area.trim()) temp.area = "Area is required";
  if (!formData.address1.trim()) temp.address1 = "Address Line 1 is required";
  if (!formData.pincode.trim()) temp.pincode = "Pincode is required";
  if (!formData.preferred_languages.length) temp.preferred_languages = "Select at least one language";
    if (!formData.profession_id) temp.profession_id = "Profession is required";
   if (!formData.profession_details) temp.profession_details = "Specialization is required";



  setErrors(temp);
  // return Object.keys(temp).length === 0;
  if (Object.keys(temp).length > 0) {
  scrollToFirstError(temp);
  return false;
}

return true;
};

//scrrol to error function
const scrollToFirstError = (errorsObj) => {
  const firstErrorField = Object.keys(errorsObj)[0];

  if (firstErrorField && fieldRefs[firstErrorField]?.current) {
    fieldRefs[firstErrorField].current.scrollIntoView({
      behavior: "smooth",
      block: "center"
    });

    fieldRefs[firstErrorField].current.focus?.();
  }
};

 
  // ------------------ UPDATE PROFILE ------------------
  const handleSubmit = async e => {
  e.preventDefault();

  let finalCityId = formData.city_id;

  // 🔥 CREATE CITY FIRST
  if (!finalCityId && cityInput) {
    finalCityId = await ensureCityExists();
  }

  // 🔥 HARD BLOCK
  // if (!finalCityId) {
  //   setErrors(prev => ({ ...prev, city: "City is required" }));
  //   return;
  // }

  // 🔥 VALIDATE USING FINAL CITY ID
  if (!validate(finalCityId)) return;

  const token = localStorage.getItem("token");
  const form = new FormData();

  // Object.keys(formData).forEach(key => {
  //   if (key !== "city_id") form.append(key, formData[key]);
  // });
  Object.keys(formData).forEach(key => {
  if (key === "preferred_languages") {
    formData.preferred_languages.forEach(id => {
      form.append("preferred_languages[]", id);
    });
  } else if (key !== "city_id") {
    form.append(key, formData[key]);
  }
});

  // 🔥 FORCE CORRECT CITY ID
  form.append("city_id", finalCityId);

  if (photo) form.append("student_profile_photo", photo);

  try {
    const res = await fetch(
      "https://kalakakshaaha.com/kks/api/student/update",
      {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: form,
      }
    );

    const data = await res.json();
    // alert(data.message);

    // if (data.success) navigate("/student-profile");
    if (data.success) {
  Swal.fire({
    icon: "success",
    title: "Updated Successfully",
    text: "Your profile has been updated successfully.",
    width: 450,              // 👈 popup width (px or %)
  heightAuto: false,       // 👈 REQUIRED to control height
   customClass: {
    popup: "custom-swal-popup"
  },
    // confirmButtonText: "OK"
    showConfirmButton: false,   // ❌ remove OK button
  timer: 2000,                // ⏱ 3 seconds
  timerProgressBar: true,     // optional progress bar
  allowOutsideClick: false,
  allowEscapeKey: false,
  didClose: () => {
    navigate("/student-profile");  // 🔁 auto redirect
  }
  }).then(() => {
    navigate("/student-profile");
  });
} else {
  Swal.fire({
    icon: "error",
    title: "Update Failed",
    text: data.message || "Something went wrong"
  });
}

  } catch (err) {
    console.log("Update error:", err);
    alert("Something went wrong");
  }
};

 const handleCityChange = (e) => {
  const value = e.target.value;

  setCityInput(value);
  setFormData(prev => ({
    ...prev,
    city_id: "" // reset while typing
  }));

  if (errors.city) {
    setErrors(prev => ({ ...prev, city: "" }));
  }

  if (!value) {
    
    setFilteredCities([]);
    setShowCitySuggestions(false);
    return;
  }

  const results = apiCities.filter(c =>
    c.city_name.toLowerCase().includes(value.toLowerCase())
  );

  setFilteredCities(results);
  setShowCitySuggestions(true);
};
const selectCity = (cityObj) => {
  setCityInput(cityObj.city_name);
  setFormData(prev => ({
    ...prev,
    city_id: cityObj.id
  }));

// 🔥 CLEAR ERROR
  setErrors(prev => ({
    ...prev,
    city: ""
  })); 
   setShowCitySuggestions(false);
};
const ensureCityExists = async () => {
  if (!cityInput) return null;
  if (formData.city_id) return formData.city_id;

  const res = await fetch(
    "https://kalakakshaaha.com/kks/api/v1/city/create-or-get",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        city_name: cityInput,
        state_id: formData.state_id,
        country_id: formData.country_id
      })
    }
  );

  const data = await res.json();

  if (data.success) {
    setFormData(prev => ({
      ...prev,
      city_id: data.city_id
    }));

    setApiCities(prev => [
      ...prev,
      { id: data.city_id, city_name: cityInput }
    ]);

    return data.city_id;
  }

  return null;
};
useEffect(() => {
  if (formData.city_id && apiCities.length > 0) {
    const found = apiCities.find(c => c.id === formData.city_id);
    if (found) {
      setCityInput(found.city_name);
    }
  }
}, [formData.city_id, apiCities]);

//for profession and student
// profession
const [professions, setProfessions] = useState([]);
useEffect(() => {
  fetch("https://kalakakshaaha.com/kks/api/v1/professions")
    .then(res => res.json())
    .then(data => {
      if (data.success) {
        setProfessions(data.professions);
      }
    });
}, []);



//laguages api
//languages
const [languageInput, setLanguageInput] = useState("");
const [languages, setLanguages] = useState([]);
const [languageSuggestions, setLanguageSuggestions] = useState([]);
const [selectedLanguages, setSelectedLanguages] = useState([]);

useEffect(() => {
  fetch("https://kalakakshaaha.com/kks/api/v1/languages")
    .then(res => res.json())
    .then(data => {
      if (data.success) {
        setLanguages(data.languages);
      }
    });

}, []);

const handleLanguageInput = (e) => {
  const value = e.target.value;
  setLanguageInput(value);
  // 🔥 CLEAR ERROR WHEN USER TYPES
  if (errors.preferred_languages) {
    setErrors(prev => ({ ...prev, preferred_languages: "" }));
  }


  if (!value) {
    setLanguageSuggestions([]);
    return;
  }

  const filtered = languages.filter(
    l =>
      l.language_name.toLowerCase().includes(value.toLowerCase()) &&
      !selectedLanguages.some(s => s.id === l.id)
  );

  setLanguageSuggestions(filtered);
};

const addLanguage = (lang) => {
  setSelectedLanguages(prev => [...prev, lang]);
  setLanguageInput("");
  setLanguageSuggestions([]);

  setFormData(prev => ({
    ...prev,
    preferred_languages: [...(prev.preferred_languages || []), lang.id]
  }));
  // 🔥 CLEAR ERROR WHEN LANGUAGE IS ADDED
  setErrors(prev => ({ ...prev, preferred_languages: "" }));

};

const removeLanguage = (id) => {
  setSelectedLanguages(prev => prev.filter(l => l.id !== id));

  setFormData(prev => ({
    ...prev,
    preferred_languages: prev.preferred_languages.filter(lid => lid !== id)
  }));
};




  return (
    <Fragment>
      <Header />
      <section className="instructor-single-section padding-tb section-bg">
        <div className="container py-4">
          <div className="card p-4 shadow mt-5 profile-card">
            <div className="text-center mb-4">
              <h3>Edit Student Profile</h3>
            </div>
 
            <div className="row">
              {/* LEFT COLUMN - PHOTO */}
              <div className="col-md-4 text-center border-end d-flex flex-column align-items-center">
                {photoPreview ? (
                  <img
                    src={photoPreview}
                    alt="preview"
                    className="rounded-circle shadow"
                    style={{ width: "150px", height: "150px", objectFit: "cover" }}
                  />
                ) : (
                  <div className="rounded-circle bg-light shadow" style={{ width: "150px", height: "150px" }} />
                )}
                <div className="mt-3 w-100">
                  <label className="form-label fw-bold">Change Profile Photo</label>
                  <input type="file" className="form-control" onChange={handlePhotoChange} />
                </div>
              </div>
 
              {/* RIGHT COLUMN - FORM */}
              <div className="col-md-8 mt-2">
                <form onSubmit={handleSubmit} className="text-start">
                  <div className="row">
                    {/* Full Name */}
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Full Name</label>
                        <input
                          type="text"
                          name="full_name"
                          ref={fieldRefs.full_name}
                          className="form-control"
                          value={formData.full_name}
                          onChange={(e) => {
                            const val = e.target.value.replace(/[^a-zA-Z\s]/g, ""); // letters + space only
                            setFormData({ ...formData, full_name: val });
                            setErrors({ ...errors, full_name: "" });
                          }}
                        />
                      {errors.full_name && <small className="text-danger">{errors.full_name}</small>}
                    </div>
 
                    {/* Email */}
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Email</label>
                      <input type="email" name="email" className="form-control" value={formData.email}  disabled  />
                      {errors.email && <small className="text-danger">{errors.email}</small>}
                    </div>
 
                    {/* Phone */}
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Phone</label>
                                            <div className="phone-row">

                       <select
                        name="phone_code"
                        
                        className="form-control"
                        style={{ width: "30%" }}
                        value={formData.phone_code}
                        onChange={handleChange}
                      >
                        <option value="+91">+91 (India)</option>
                        <option value="+1">+1 (USA)</option>
                        <option value="+44">+44 (UK)</option>
                      </select>

                      <input type="text" style={{ width: "75%" }} ref={fieldRefs.phone}
                      name="phone" className="form-control" value={formData.phone} maxLength={10} onChange={handleChange} />
                      {errors.phone && <small className="text-danger">{errors.phone}</small>}
                      </div>
                    </div>
 
                     {/* Gender */}
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Gender</label>
                      <select name="gender" className="form-control" ref={fieldRefs.gender} value={formData.gender} onChange={handleChange}>
                        <option value="">Select</option>
                        <option value="male">Male</option>
                        <option value="female">Female</option>
                        <option value="Other">Other</option>
                      </select>
                      {errors.gender && <small className="text-danger">{errors.gender}</small>}
                    </div>
 
                    {/* Date of Birth */}
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Date of Birth</label>
                      <input
                        type="date"
                        name="dob"
                        ref={fieldRefs.dob}
                        className="form-control"
                        value={formData.dob}
                        onChange={handleChange}
                        max={new Date().toISOString().split("T")[0]}
                      />
                      {errors.dob && <small className="text-danger">{errors.dob}</small>}
                    </div>
 
 
                    
                    {/* PROFESSION DROPDOWN */}
                        <div className="col-md-6 mb-3">
                             <label className="form-label">Profession</label>

                          <select
                            name="profession_id"
                            ref={fieldRefs.profession_id}
                            className="form-control"
                            value={formData.profession_id}
                            onChange={handleChange}
                          >
                            <option value="">Select Profession</option>
                            {professions.map(p => (
                              <option key={p.id} value={p.id}>
                                {p.profession_name}
                              </option>
                            ))}
                          </select>

                          {/* {errors.profession_id && (
                            <p className="validation-msg show">{errors.profession_id}</p>
                          )} */}
                           {errors.profession_id && <small className="text-danger">{errors.profession_id}</small>}

                        </div>

                        {/* PROFESSION DETAILS */}
                        <div className="col-md-6 mb-3">
                          
                           <label className="form-label">Specialization</label>

                          <input 
                            type="text" 
                            ref={fieldRefs.profession_details}
                            name="profession_details" 
                            placeholder="Specialisation" 
                            className="form-control" 
                            value={formData.profession_details} 
                            onChange={handleChange} 
                        />
                          {errors.profession_details && <small className="text-danger">{errors.profession_details}</small>}

                        </div>

                        {/* PREFERRED LEARNING LANGUAGE */}
                        <div className="language-field col-md-6 mb-3">
  <label className="form-label">Preferred Learning Language <span className="text-danger">*</span></label>

  <div className="language-input-box">
    {selectedLanguages.map(lang => (
      <span key={lang.id} className="language-chip">
        {lang.language_name}
        <button type="button" onClick={() => removeLanguage(lang.id)}>×</button>
      </span>
    ))}

    <input
      type="text"
      ref={fieldRefs.preferred_languages}
      className="language-text-input"
      placeholder="Type language..."
      value={languageInput}
      onChange={handleLanguageInput}
    />
  </div>

  {errors.preferred_languages && (
    <small className="text-danger">{errors.preferred_languages}</small>
  )}


  {languageSuggestions.length > 0 && (
    <ul className="language-suggestions">
      {languageSuggestions.map(l => (
        <li key={l.id} onClick={() => addLanguage(l)}>
          {l.language_name}
        </li>
      ))}
    </ul>
  )}
                        </div>


 
                   {/* Country */}
                    <div className="col-md-6 mb-3">
  <label className="form-label">Country</label>
  <select name="country_id" ref={fieldRefs.country} className="form-control" value={formData.country_id} onChange={handleChange}>
  <option value="">Select Country</option>
  {apiCountries.map(c => (
    <option key={c.id} value={c.id}>{c.country_name}</option>
  ))}
</select>

  {errors.country && <small className="text-danger">{errors.country}</small>}
                    </div>
 
                    {/*State */}
                    <div className="col-md-6 mb-3">
                      <label className="form-label">State</label>
                      <select
                      name="state_id" ref={fieldRefs.state} className="form-control"
                      value={formData.state_id}
                      onChange={handleChange}
                      disabled={!formData.country_id}
                    >
                      <option value="">Select State</option>
                      {apiStates.map(s => (
                        <option key={s.id} value={s.id}>{s.state_name}</option>
                      ))}
                    </select>
                      {errors.state && <small className="text-danger">{errors.state}</small>}
                    </div>
 
                    {/* City with autocomplete */}
                    {/* <div className="col-md-6 mb-3 position-relative">
                        <label className="form-label">City</label>

                     <select
  name="city_id"
  value={formData.city_id}
  onChange={handleChange}
  disabled={!formData.state_id}
>
  <option value="">Select City</option>
  {apiCities.map(c => (
    <option key={c.id} value={c.id}>{c.city_name}</option>
  ))}
</select>
                    </div>
                    */}

                      {/* City with autocomplete */}
                    <div className="col-md-6 mb-3 position-relative">
                      <label className="form-label">City</label>

                      <input
                        type="text"
                        ref={fieldRefs.city}
                        className="form-control"
                        placeholder="Type city name"
                        value={cityInput}
                        onChange={handleCityChange}
                        disabled={!formData.state_id}
                        autoComplete="off"
                      />

                      {showCitySuggestions && filteredCities.length > 0 && (
                        <ul
                          className="suggestions-list"
                          style={{
                            position: "absolute",
                            width: "100%",
                            background: "#fff",
                            border: "1px solid #ddd",
                            zIndex: 20,
                            maxHeight: "200px",
                            overflowY: "auto"
                          }}
                        >
                          {filteredCities.map(c => (
                            <li
                              key={c.id}
                              onClick={() => selectCity(c)}
                              style={{ padding: "8px", cursor: "pointer" }}
                            >
                              {c.city_name}
                            </li>
                          ))}
                        </ul>
                      )}

                      {errors.city && <small className="text-danger">{errors.city}</small>}
                    </div>

                    {/* Location */}
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Location</label>
                      <input type="text" name="location" ref={fieldRefs.location} className="form-control" value={formData.location} onChange={handleChange} />
                      {errors.location && <small className="text-danger">{errors.location}</small>}
                    </div>
 
                    {/* Area */}
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Area</label>
                      <input type="text" name="area" ref={fieldRefs.area} className="form-control" value={formData.area} onChange={handleChange} />
                      {errors.area && <small className="text-danger">{errors.area}</small>}
                    </div>
 
                    {/* Address1 */}
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Address Line 1</label>
                      <input type="text" ref={fieldRefs.address1} name="address1" className="form-control" value={formData.address1} onChange={handleChange} />
                      {errors.address1 && <small className="text-danger">{errors.address1}</small>}
                    </div>
 
                    {/* Address2 */}
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Address Line 2</label>
                      <input type="text" name="address2" className="form-control" value={formData.address2} onChange={handleChange} />
                    </div>
 
                    {/* Pincode */}
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Pincode/ZIP</label>
<input
  type="text"
  ref={fieldRefs.pincode}
  name="pincode"
  className="form-control"
  value={formData.pincode}
  maxLength={6}
  onChange={(e) => {
    const val = e.target.value.replace(/\D/g, ""); // numbers only
    setFormData({ ...formData, pincode: val });
    setErrors({ ...errors, pincode: "" });
  }}
/>
                      {errors.pincode && <small className="text-danger">{errors.pincode}</small>}
                    </div>
                  </div>
 
                  <button className="lab-btn mt-3"><span>Update Profile</span></button>
                  <button type="button" className="lab-btn mt-3 ms-3" style={{ background: "#999" }} onClick={() => navigate("/student-profile")}>
                    <span>Cancel</span>
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </Fragment>
  );
};
 
export default EditStudentProfile;
